import { render, staticRenderFns } from "./ListadoPlazosImpagados.vue?vue&type=template&id=3571e73c&scoped=true"
import script from "./ListadoPlazosImpagados.vue?vue&type=script&lang=js"
export * from "./ListadoPlazosImpagados.vue?vue&type=script&lang=js"
import style0 from "./ListadoPlazosImpagados.vue?vue&type=style&index=0&id=3571e73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571e73c",
  null
  
)

export default component.exports